import request from '@/utils/request'
import { Api as api } from '@/common/config'

/**
 * 登录
 */
export function login(data) {
  return request({
    url: api + '/api/auth/loginByPassword',
    method: 'post',
    data
  })
}

/**
 * 注册
 */
export function regist(data) {
  return request({
    url: api + '/api/auth/add',
    method: 'post',
    data
  })
}

/**
 * 获取验证码
 */
export function getSmsCode(data) {
  return request({
    url: api + '/api/auth/sendSmsCodeByMobile',
    method: 'post',
    data
  })
}

/**
 * 找回密码
 */
export function resetPassword(data) {
  return request({
    url: api + '/api/auth/resetPasswordByMobile',
    method: 'post',
    data
  })
}

/**
 * 找回密码发送验证码
 */
export function getResetSmsCode(data) {
  return request({
    url: api + '/api/auth/sendResetPasswordSmsCodeByMobile',
    method: 'post',
    data
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo(data) {
  return request({
    url: api + '/api/auth/detail',
    method: 'post',
    data
  })
}

/**
 * 编辑用户信息
 */
export function editUserInfo(data) {
  return request({
    url: api + '/api/auth/edit',
    method: 'post',
    data
  })
}

/**
 * 获取兴趣标签
 */
export function getInterestingList(data) {
  return request({
    url: api + '/api/label/list',
    method: 'post',
    data
  })
}

/**
 * 用户添加兴趣标签
 */
export function addInteresting(data) {
  return request({
    url: api + '/api/auth/addInterestingLabel',
    method: 'post',
    data
  })
}

/**
 * 用户签到
 */
export function userSign(data) {
  return request({
    url: api + '/api/auth/userSign',
    method: 'post',
    data
  })
}


/**
 * 积分明细
 */
export function getPointList(data) {
  return request({
    url: api + '/api/userPoint/list',
    method: 'post',
    data
  })
}

/**
 * 获取积分规则列表
 */
export function getPointRuleList(data) {
  return request({
    url: api + '/api/pointRule/list',
    method: 'post',
    data
  })
}

export function getPointRuleList2(data) {
  return request({
    url: api + '/api/pointRule/detail',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js